var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.445312,
    y: 0.686279,
    width: 45.1096,
    height: 45.0959,
    rx: 22.5479,
    fill: "#19B3B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.774 23.0503C12.774 18.9643 14.97 16.1923 18.336 16.1923C21.702 16.1923 23.916 18.9643 23.916 23.0503C23.916 27.1183 21.828 29.8363 18.336 29.8363C14.844 29.8363 12.774 27.1183 12.774 23.0503ZM15.042 23.0503C15.042 26.0923 16.266 27.8023 18.336 27.8023C20.424 27.8023 21.648 26.0923 21.648 23.0503C21.648 19.9363 20.424 18.2263 18.336 18.2263C16.266 18.2263 15.042 19.9363 15.042 23.0503ZM28.1834 18.5143H25.3034V16.4443H30.3974V29.6023H28.1834V18.5143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4453 23.4736L21.2886 27.261L28.9721 19.6863",
    stroke: "white",
    strokeWidth: 2.1642,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew11);
export default __webpack_public_path__ + "static/media/new11.1abbc0b455ca217232a2de26b66a4e97.svg";
export { ForwardRef as ReactComponent };